module.exports = __webpack_public_path__ + "img/ipadpro-9_TP_V4.399839f1.png";